import { render } from "./TemplateThree.vue?vue&type=template&id=ea22abc0"
import script from "./TemplateThree.vue?vue&type=script&lang=js"
export * from "./TemplateThree.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__